var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',{staticClass:"search"},[_vm._v(" "+_vm._s(_vm.$t('Search.title'))+" ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }